export default function SameRaceMultiField() {
  return <span>Coming soon</span>;
}
